import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';
import { IconBasketOutlined, IconBasketSolid, IconHeartOutlined, IconHeartSolid, IconMenu, IconSearch } from '@noths/polaris-client-ribbons-design-system';
import { ICON_BUTTON_TEXT_CLASS } from '@noths/polaris-client-styles';
import { IconBarItem, IconBarItemLabel } from "./IconBarItem";
import { MyAccount } from "./MyAccount";
import * as styles from "./IconBar.styles";
import { BASKET_PAGE_HREF, FAVOURITES_PAGE_HREF } from "../../../constants/hrefs";
import { useSiteChromeDynamicContext } from "../../../context/SiteChromeDynamicContext/useSiteChromeDynamicContext";
import { useUserContext } from "../../../context/UserContext/useUserContext";
var BasketItemsCount = function BasketItemsCount(_ref) {
  var count = _ref.count;
  return /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css: styles.basketCount
  }, /*#__PURE__*/React.createElement("span", {
    "data-testid": "basket-items-count"
  }, count));
};
var baseTrackingEvent = {
  event: 'custom_event',
  event_category: 'Header'
};
var favoritesClickTrackingEvent = _objectSpread(_objectSpread({}, baseTrackingEvent), {}, {
  event_action: 'favourites click',
  event_label: 'Favourites'
});
var basketClickTrackingEvent = _objectSpread(_objectSpread({}, baseTrackingEvent), {}, {
  event_action: 'basket click',
  event_label: 'Basket'
});
export var IconBar = function IconBar(_ref2) {
  var compact = _ref2.compact,
    onSearchIconClick = _ref2.onSearchIconClick,
    searchIconActive = _ref2.searchIconActive;
  var _useUserContext = useUserContext(),
    basketItemsCount = _useUserContext.basketItemsCount,
    hasFavouriteProducts = _useUserContext.hasFavouriteProducts;
  var _useSiteChromeDynamic = useSiteChromeDynamicContext(),
    navigationModal = _useSiteChromeDynamic.navigationModal;
  var _useTrackableLink = useTrackableLink(),
    trackLinkClick = _useTrackableLink.trackLinkClick,
    trackLinkMouseDown = _useTrackableLink.trackLinkMouseDown;
  return /*#__PURE__*/React.createElement(_StyledUl, {
    $_css2: styles.iconbar
  }, compact && /*#__PURE__*/React.createElement(IconBarItem, {
    visibleBelowBreakpoint: "M"
  }, /*#__PURE__*/React.createElement(_StyledButton, {
    "data-testid": "button-icon-search",
    onClick: onSearchIconClick,
    type: "button",
    $_css3: styles.iconBtn
  }, /*#__PURE__*/React.createElement(_StyledIconSearch, {
    color: searchIconActive ? 'var(--brand-purple-base)' : 'var(--neutral-black-base)',
    $_css4: styles.icon
  }))), /*#__PURE__*/React.createElement(MyAccount, null), /*#__PURE__*/React.createElement(IconBarItem, {
    visibleAboveBreakpoint: compact ? 'S' : undefined
  }, /*#__PURE__*/React.createElement(_StyledA, {
    href: FAVOURITES_PAGE_HREF,
    onClick: trackLinkClick(favoritesClickTrackingEvent),
    onMouseDown: trackLinkMouseDown(favoritesClickTrackingEvent),
    $_css5: styles.link
  }, hasFavouriteProducts ? /*#__PURE__*/React.createElement(_StyledIconHeartSolid, {
    $_css6: styles.icon
  }) : /*#__PURE__*/React.createElement(_StyledIconHeartOutlined, {
    $_css7: styles.icon
  }), /*#__PURE__*/React.createElement(IconBarItemLabel, null, "Favourites"))), /*#__PURE__*/React.createElement(IconBarItem, null, /*#__PURE__*/React.createElement(_StyledA2, {
    href: BASKET_PAGE_HREF,
    onClick: trackLinkClick(basketClickTrackingEvent),
    onMouseDown: trackLinkMouseDown(basketClickTrackingEvent),
    $_css8: styles.link
  }, basketItemsCount ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledIconBasketSolid, {
    $_css9: styles.icon
  }), /*#__PURE__*/React.createElement(BasketItemsCount, {
    count: basketItemsCount
  })) : /*#__PURE__*/React.createElement(_StyledIconBasketOutlined, {
    $_css10: styles.icon
  }), /*#__PURE__*/React.createElement(IconBarItemLabel, null, "Basket"))), navigationModal && /*#__PURE__*/React.createElement(IconBarItem, {
    visibleBelowBreakpoint: "L"
  }, /*#__PURE__*/React.createElement(_StyledButton2, {
    onClick: navigationModal.open,
    type: "button",
    $_css11: styles.iconBtn
  }, /*#__PURE__*/React.createElement(_StyledIconMenu, {
    $_css12: styles.icon
  }), /*#__PURE__*/React.createElement("span", {
    className: ICON_BUTTON_TEXT_CLASS
  }, "Open Navigation"))));
};
var _StyledSpan = _styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledUl = _styled2("ul")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledButton = _styled3("button")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledIconSearch = _styled4(IconSearch)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledA = _styled5("a")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledIconHeartSolid = _styled6(IconHeartSolid)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledIconHeartOutlined = _styled7(IconHeartOutlined)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledA2 = _styled8("a")(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css8;
});
var _StyledIconBasketSolid = _styled9(IconBasketSolid)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css9;
});
var _StyledIconBasketOutlined = _styled10(IconBasketOutlined)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css10;
});
var _StyledButton2 = _styled11("button")(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css11;
});
var _StyledIconMenu = /*#__PURE__*/_styled12(IconMenu).withConfig({
  displayName: "IconBar___StyledIconMenu",
  componentId: "sc-1uvaj9f-0"
})(["", ""], function (p) {
  return p.$_css12;
});